import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu } from "antd";

const cleanIcon = (icon) => {
  if (!icon || !React.isValidElement(icon)) return null;
  return React.cloneElement(icon, {
    className: undefined,
    style: { display: "flex", alignItems: "center", justifyContent: "center" },
  });
};

export const buildMenuItems = (menuItems) => {
  return menuItems.map((item) => {
    const icon = cleanIcon(item.icon);
    if (item.children && item.children.length > 0) {
      return {
        key: String(item.id ?? item.key ?? item.label),
        icon,
        label: item.label,
        children: buildMenuItems(item.children),
      };
    }
    return {
      key: item.path ?? String(item.id ?? item.key),
      icon,
      label: item.label,
    };
  });
};

const SidebarMenu = ({ menuItems, collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = ({ key }) => {
    if (key && key.startsWith("/")) navigate(key);
  };

  const items = buildMenuItems(menuItems);

  return (
    <Menu
      // KEY FIX: "vertical" when collapsed → shows popup flyouts
      //          "inline" when expanded → shows inline submenus
      mode={collapsed ? "vertical" : "inline"}
      selectedKeys={[location.pathname]}
      defaultOpenKeys={[]}
      inlineIndent={12}
      items={items}
      onSelect={handleSelect}
      // Render ALL popups (tooltips + submenus) into body so they
      // are never clipped by the sidebar overflow
      getPopupContainer={() => document.body}
      style={{
        background: "transparent",
        border: "none",
        overflow: "visible",
      }}
    />
  );
};

export default SidebarMenu;

export const dynamicAdminSuperadmin = (menuItems) => buildMenuItems(menuItems);